const ERROR_MESSAGES = {
    'auth/invalid-email': 'Invalid email address.',
    'auth/too-many-requests': 'Too many login attempts. Please try again later.',
    'auth/network-request-failed': 'Network error. Please check your internet connection and try again.',
};

export const SIGN_IN_ERROR_MESSAGES = {
    ...ERROR_MESSAGES,
    'auth/user-not-found': 'Invalid email or password.',
    'auth/wrong-password': 'Invalid email or password.',
    'auth/invalid-credential': 'Invalid email or password.',
    'auth/user-disabled': 'This user account has been disabled.',
    'auth/popup-closed-by-user': 'The sign-in popup was closed before completing.',
    'auth/cancelled-popup-request': 'Multiple sign-in attempts detected. Please try again.',
    'auth/popup-blocked': 'Your browser blocked the sign-in popup.',
    'auth/account-exists-with-different-credential': 'An account already exists with a different sign-in method.',
    'auth/credential-already-in-use': 'This credential is already linked to another account.',
    'auth/operation-not-allowed': 'Sign-in method not allowed. Please contact support.',
};

export const SIGN_UP_ERROR_MESSAGES = {
    ...ERROR_MESSAGES,
    'auth/user-not-found': 'No account found with this email address.',
    'auth/email-already-in-use': 'An account already exists with this email address.',
    'auth/weak-password': 'Password is too weak.',
    'auth/operation-not-allowed': 'Email/password sign-up is not enabled. Please contact support.',
};

export const FORGOT_PASSWORD_ERROR_MESSAGES = {
    ...ERROR_MESSAGES,
    'auth/user-not-found': 'No account found with this email address.',
    'auth/missing-continue-uri': 'An error occurred. Please try again later.',
    'auth/unauthorized-continue-uri': 'An error occurred. Please contact support.',
    'auth/quota-exceeded': 'Too many password reset requests. Please try again later.',
    'auth/user-token-expired': 'Your session has expired. Please try again.',
    'auth/requires-recent-login': 'Please sign in again to reset your password.',
};

export const VERIFY_RESET_CODE_ERROR_MESSAGES = {
    ...ERROR_MESSAGES,
    'auth/user-not-found': 'No account found with this email address.',
    'auth/invalid-action-code': 'This reset link is invalid or has expired.',
    'auth/expired-action-code': 'This reset link has expired.',
};

export const RESET_PASSWORD_ERROR_MESSAGES = {
    ...ERROR_MESSAGES,
    'auth/user-not-found': 'No account found with this email address.',
    'auth/invalid-action-code': 'The reset link is no longer valid. Please request a new one.',
    'auth/expired-action-code': 'The reset link has expired. Please request a new one.',
    'auth/weak-password': 'Password is too weak.',
};

export const PHONE_VERIFICATION_ERROR_MESSAGES = {
    ...ERROR_MESSAGES,
    'auth/user-not-found': 'No account found with this email address.',
    'auth/captcha-check-failed': 'Captcha failed. Try again.',
    'auth/invalid-phone-number': 'Invalid phone number.',
    'auth/phone-number-already-exists': 'Phone already in use.',
    'auth/credential-already-in-use': 'Phone already in use.',
    'auth/invalid-verification-code': 'Incorrect code.',
    'auth/code-expired': 'Code expired. Request a new one.',
    'auth/requires-recent-login': 'Please sign in again to complete phone verification.',
};

export const EMAIL_VERIFICATION_ERROR_MESSAGES = {
    ...ERROR_MESSAGES,
    'auth/user-not-found': 'No account found with this email address.',
    'auth/invalid-action-code': 'This verification link is invalid or has already been used.',
    'auth/expired-action-code': 'This verification link has expired.',
};

type ErrorMap = Record<string, string>;

export const getErrorMessage = (
  error: { code?: string; message?: string } | unknown,
  errorMap: ErrorMap = ERROR_MESSAGES,
): string => {
  const code = (error as { code?: string })?.code;
  return errorMap[code ?? ""] || (error as { message?: string })?.message || "An unexpected error occurred.";
};
